import React, {useEffect, useState} from "react";
import {apiFetch} from "../../utils/api";
import {BASE_URLS} from "../../config/urls";
import { ModalShell } from "./ModalShell";
import {UserProfile} from "../../types/form";
import {BtnSpinner} from "../fields/BtnSpinner";

export function EditProfileModal({
                                     isOpen,
                                     initial,
                                     onClose,
                                     onSaved,
                                     onOpenPassword,
                                 }: {
    isOpen: boolean;
    initial: UserProfile;
    onClose: () => void;
    onSaved: (next: UserProfile) => void;
    onOpenPassword: () => void;
}) {
    const [name, setName] = useState(initial.name || "");
    const [email, setEmail] = useState(initial.email || "");
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        if (isOpen) {
            setName(initial.name || "");
            setEmail(initial.email || "");
            setSaving(false);
            setErr("");
        }
    }, [isOpen, initial.name, initial.email]);

    if (!isOpen) return null;

    const save = async () => {
        setErr("");
        setSaving(true);
        try {
            if (!name.trim()) throw new Error("Введите имя");
            if (!email.trim()) throw new Error("Введите email");

            // ⚠️ подстрой под свой эндпоинт
            const resp = await apiFetch(`${BASE_URLS.api}/change_person`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name: name.trim(), email: email.trim() }),
            });

            const data = await resp.json();

            if (!resp.ok) {
                throw new Error(data.message);
            }

            onSaved({ name: name.trim(), email: email.trim() });
            onClose();
        } catch (e: any) {
            setErr(e?.message || "Ошибка сохранения");
        } finally {
            setSaving(false);
        }
    };

    return (
        <ModalShell
            title="Изменение профиля"
            subtitle="Обновите имя и почту"
            onClose={onClose}
        >
            {err && <div className="profile-error">{err}</div>}

            <div className="profile-modal-grid">
                <div className="profile-field">
                    <label className="profile-label">Имя</label>
                    <input
                        className="profile-input"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Ваше имя"
                    />
                </div>

                <div className="profile-field">
                    <label className="profile-label">Email</label>
                    <input
                        className="profile-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="name@mail.com"
                    />
                </div>
            </div>

            <div className="profile-modal-actions profile-modal-actions--between">
                <button className="profile-secondary-btn" onClick={onOpenPassword} disabled={saving}>
                    Изменить пароль
                </button>

                <div className="profile-modal-actions-right">
                    <button className="profile-secondary-btn" onClick={onClose} disabled={saving}>
                        Отмена
                    </button>
                    <button className="profile-primary-btn" onClick={save} disabled={saving}>
                        {saving ? <BtnSpinner/> : "Сохранить"}
                    </button>
                </div>
            </div>
        </ModalShell>
    );
}